import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import Logo from "@Components/Icons/Logos/LogoText";
import styles from "./index.module.scss";
export default class PrimaryNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            closed: true,
            subMenuStatus: {},
        };
    }
    toggle() {
        const { closed } = this.state;
        this.setState({ closed: !closed });
    }
    openSubMenu(path) {
        this.setState((previousState) => ({
            subMenuStatus: {
                ...previousState.subMenuStatus,
                [path]: !previousState.subMenuStatus[path],
            },
        }));
    }
    siblingLinkSelected = (path, subNav) => {
        return subNav.some(({ path: siblingPath }) => window.location.pathname.includes(siblingPath) &&
            siblingPath !== path);
    };
    renderLink = ({ path, name, style, exact = false, icon = false, subNav = [] }, sectioned = false) => subNav.length > 0 ? (React.createElement(Fragment, { key: path },
        React.createElement("button", { className: `${styles.dropdown} ${sectioned ? styles.sectionedLink : styles.link} ${subNav.some(({ path: subPath }) => window.location.pathname.includes(subPath))
                ? sectioned
                    ? styles.sectionedLinkSelected
                    : styles.selected
                : ""}`, onClick: () => this.openSubMenu(path) },
            icon,
            React.createElement("div", { className: `${styles.text} ${style}` }, name)),
        React.createElement("div", { className: `${styles.subLinks} ${this.state.subMenuStatus[path]
                ? styles.openSubLinks
                : ""}` },
            subNav.map(({ path: subPath, name: subName, style: subStyle, exact: subExact = false, }, index) => (React.createElement(Fragment, { key: subPath },
                React.createElement(NavLink, { to: subPath, className: sectioned
                        ? styles.sectionedSubLink
                        : `${styles.subLink} ${this.siblingLinkSelected(subPath, subNav)
                            ? styles.subLinkSiblingSelected
                            : ""}`, activeClassName: sectioned
                        ? styles.sectionedLinkSelected
                        : styles.subLinkSelected, exact: subExact },
                    !sectioned && (React.createElement("div", { className: styles.subNav },
                        React.createElement("div", { className: styles.prefix }))),
                    React.createElement("div", { className: `${styles.text} ${subStyle}` }, subName)),
                !sectioned && index !== subNav.length - 1 && (React.createElement("div", { className: `${styles.subLink} ${styles.gap} ${this.siblingLinkSelected("", subNav)
                        ? styles.subLinkSiblingSelected
                        : ""}` },
                    React.createElement("div", { className: `${styles.subNav} ${styles.subNavGap}` },
                        React.createElement("div", { className: styles.prefix })),
                    React.createElement("div", { className: `${styles.text} ${subStyle}` })))))),
            !sectioned && (React.createElement("div", { className: `${styles.subLinksBottom} ${this.siblingLinkSelected("", subNav)
                    ? styles.subLinksBottomSelected
                    : ""}` }))))) : (React.createElement(NavLink, { to: path, key: path, className: sectioned ? styles.sectionedLink : styles.link, activeClassName: sectioned ? styles.sectionedLinkSelected : styles.selected, exact: exact },
        icon,
        React.createElement("div", { className: `${styles.text} ${style}` }, name)));
    render() {
        const { closed } = this.state;
        const { linkSections, topLinks = [], variant = "default" } = this.props;
        const isSectioned = variant === "sectioned" && !!linkSections?.length;
        const sectionedLinks = (linkSections || []).map(({ title, links }, index) => (React.createElement("div", { key: title || `section-${index}`, className: styles.section },
            title && (React.createElement("div", { className: styles.sectionTitle }, title)),
            links.map((link) => this.renderLink(link, true)))));
        const topLinksRendered = topLinks.map((link) => this.renderLink(link));
        const bottomLinks = (this.props.bottomLinks || []).map(({ path, name, style, exact = false, icon = false }) => (React.createElement(NavLink, { to: path, key: path, className: isSectioned ? styles.sectionedLink : styles.link, activeClassName: isSectioned
                ? styles.sectionedLinkSelected
                : styles.selected, exact: exact },
            icon,
            React.createElement("div", { className: `${styles.text} ${style}` }, name))));
        return (React.createElement("div", { className: `${styles.nav} ${closed ? `` : styles.expanded} ${isSectioned ? styles.sectioned : ""} ${this.props.className || ""}` },
            React.createElement("div", { className: `${styles.header}` },
                React.createElement(Logo, null),
                React.createElement("div", { className: styles.iconContainer, onClick: this.toggle.bind(this) },
                    React.createElement("div", { className: styles.icon },
                        React.createElement("div", { className: styles.menu })))),
            React.createElement("div", { className: styles.navContainer }, isSectioned ? (React.createElement(React.Fragment, null,
                sectionedLinks,
                this.props.children,
                bottomLinks.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.expander }),
                    React.createElement("div", { className: styles.footerLinks }, bottomLinks))))) : (React.createElement(React.Fragment, null,
                topLinksRendered.length > 0 && (React.createElement("div", { className: styles.links }, topLinksRendered)),
                this.props.children,
                bottomLinks.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.expander }),
                    React.createElement("div", { className: styles.links }, bottomLinks))))))));
    }
}
